module.exports = __webpack_public_path__ + "static/media/account_icon_level1.ec3c39cf.svg";